<template>
  <v-dialog
    v-model="showModal"
    max-width="600"
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon class="icon-style">
          mdi-pencil
        </v-icon>Edit Price Status
      </h2>
      <form>
        <v-container>
          <v-row
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col
              cols="12"
              md="8"
            >
              <v-card-text class="text-body-1 text-center">
                <p class="my-p-style">
                  Update Price Status
                </p>
                <br>
                <v-select
                  v-model="priceStatus"
                  menu-props="auto"
                  :items="priceStatusList"
                  item-value="id"
                  item-text="name"
                  label="Price Status"
                  dense
                  outlined
                  single-line
                />
              </v-card-text>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-btn
              class="mt-2"
              color="red darken-3"
              @click="showModal = false"
            >
              cancel
            </v-btn>
            <v-spacer />
            <v-btn
              class="mt-2"
              color="#FF3700"
              @click="UpdatePriceStatus()"
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-container>
      </form>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-dialog>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'EditPriceStatus',
    components: {
      'centre-spinner': spinner,
    },
    props: {
      status: {
        type: Boolean,
        default: null,
      },
      priceId: {
        default: null,
        type: String,
      },
    },
    data () {
      return {
        showModal: true,
        priceStatus: '',
        loading: false,
        priceStatusList: [{ name: 'Active', id: true }, { name: 'Inactive', id: false }],
      };
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    async mounted () {
      this.loading = true;
      this.priceStatus = this.status;
      this.loading = false;
    },
    methods: {
      UpdatePriceStatus () {
        this.loading = true;
        this.$store.dispatch('payments/updatePriceStatus', {
          priceStatus: { active: this.priceStatus },
          priceId: this.priceId,
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Price Status updated successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.$emit('success');
          this.loading = false;
          this.showModal = false;
        }).catch(() => {
          this.loading = false;
        });
      },

    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.my-p-style {
  font-size: 18px;
  font-weight: bold;
  color: #546E7A;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  text-align: center;
}
</style>
